module.exports = __webpack_public_path__ + "static/media/works3.deeba28f.png";